import { useState, useCallback } from 'react';

import { RoutesPoints, resetRoutesPoints } from '../types/routesPoints';

const useRoutesPoints = () => {
  const [routesPoints, setRoutesPoints] = useState<RoutesPoints>();

  const resetRoutesPoints: resetRoutesPoints = useCallback(() => {
    setRoutesPoints(undefined);
  }, [setRoutesPoints]);

  return { routesPoints, setRoutesPoints, resetRoutesPoints };
};

export default useRoutesPoints;
